import React, {useEffect, useRef, useState} from 'react'
import {NavLink} from "react-router-dom";
import {NAVIGATION_ITEM} from "../../../../constants/navigationItems";
import {getFromLocalStorageWithDefault, KEY_LAST_EVENTS, saveToLocalStorage} from "../../../../util/localStorageZugriff";

/**
 * Zuletzt besuchte Events im neuen Design, ersetzt in den neuen Ansichten die LastEventComp.
 * Die Leiste zeigt das zuletzt besuchte andere Event, aufgeklappt die weiteren aus dem Verlauf.
 *
 * @param currentId aktuelles Event, wird nicht angeboten
 * @param onLoad optional; ohne wird per Link auf das Event navigiert, mit wird es über onLoad(id) geladen
 */
export default function LetzteEvents({currentId, onLoad}) {

    const [events, setEvents] = useState([]);
    const [offen, setOffen] = useState(false);
    const bereichRef = useRef(null);

    useEffect(() => {
        setEvents(getFromLocalStorageWithDefault(KEY_LAST_EVENTS, []));
        setOffen(false);
    }, [currentId]);

    useEffect(() => {
        if (!offen) {
            return;
        }
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                setOffen(false);
            }
        };
        const handleKlick = (event) => {
            if (bereichRef.current && !bereichRef.current.contains(event.target)) {
                setOffen(false);
            }
        };
        document.addEventListener("keydown", handleKeyDown);
        document.addEventListener("mousedown", handleKlick);
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("mousedown", handleKlick);
        };
    }, [offen]);

    const andereEvents = events.filter(e => e.id !== currentId);
    if (andereEvents.length === 0) {
        return null;
    }
    const erstes = andereEvents[0];

    const leereVerlauf = () => {
        saveToLocalStorage(KEY_LAST_EVENTS, []);
        setEvents([]);
        setOffen(false);
    }

    const getEventLink = (event, className) => {
        if (onLoad === undefined) {
            return <NavLink to={NAVIGATION_ITEM.PUBLIC_TOURNAMENT.route + "/" + event.id} className={className}
                            onClick={() => setOffen(false)}>{event.name}</NavLink>;
        }
        return <button type="button" className={className} onClick={() => {
            setOffen(false);
            onLoad(event.id);
        }}>{event.name}</button>;
    }

    return <div className="dhpt-le" ref={bereichRef}>
        <div className="dhpt-le-leiste">
            <i className="pi pi-history dhpt-le-icon" aria-hidden="true"/>
            <span className="dhpt-le-label">Zuletzt besucht</span>
            {getEventLink(erstes, "dhpt-le-erstes")}
            <button type="button" className="dhpt-le-toggle" aria-expanded={offen} aria-controls="dhpt-le-liste"
                    onClick={() => setOffen(!offen)}>
                <span>Verlauf ({andereEvents.length})</span>
                <i className={offen ? "pi pi-chevron-up" : "pi pi-chevron-down"} aria-hidden="true"/>
            </button>
        </div>
        {offen &&
            <div className="dhpt-le-panel" id="dhpt-le-liste">
                <ul className="dhpt-le-liste">
                    {andereEvents.map(event => <li key={"le_" + event.id + "_" + event.type}>
                        {getEventLink(event, "dhpt-le-eintrag")}
                    </li>)}
                </ul>
                <button type="button" className="dhpt-le-leeren" onClick={leereVerlauf}>
                    <i className="pi pi-trash" aria-hidden="true"/>
                    <span>Verlauf leeren</span>
                </button>
            </div>
        }
    </div>
}
